import { Box, IconButton, Menu, MenuItem, Tab, Tabs } from "@mui/material";
import { Link } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import { useState } from "react";

const CustomInPageNavigation = ({ page, data }) => {
  const subPages = page.parentPage?.subPages || [];
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  if (!subPages.length) return null; // No subpages to display

  const subPagesConfig = subPages.filter((p) => p.config);
  const subPagesStandard = subPages.filter((p) => !p.config);

  const tabsPage = subPagesStandard.find((p) => p.path === page.path);

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Tabs value={tabsPage ? page.path : null} variant="scrollable">
        {subPagesStandard.map((subpage, index) => {
          return (
            <Tab
              key={index}
              label={subpage.title}
              component={Link}
              to={"../" + subpage.path}
              value={subpage.path}
            />
          );
        })}
        {subPagesConfig.length > 0 && (
          <Tab value={null} onClick={handleClick} label={<SettingsIcon />} />
        )}
      </Tabs>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {subPagesConfig.map((subpage, index) => {
          return (
            <MenuItem
              key={index}
              component={Link}
              onClick={handleClose}
              to={"../" + subpage.path}
            >
              {subpage.title}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};

export default CustomInPageNavigation;
